<template>
  <section class="login-container reset-password">
    <p>新しいパスワードを入力してください。</p>

    <div class="input-container">
      <form @submit.prevent="submit">
        <input type="text" v-model="req.email" name="password" id="password" disabled placeholder="ログイン用のメールアドレスを入力">
        <input type="password" v-model="req.password" name="password" id="password" placeholder="新しいパスワードを入力"
          autocomplete="new-password">
        <input type="password" v-model="req.password_confirmation" name="password_confirmation" id="password"
          placeholder="もう一度同じパスワードを入力" autocomplete="new-password">

        <p class="notice danger-text bold">
          セキュリティ上、リセットを行うと過去に発行したQRコードが無効化されます。<br>
          リセットに伴い以前のパスワードとQRコードでログインしている端末ではログアウトされます。<br>
          QRコードログインを併用している場合はリセットが成功したことを確認した後、管理者へQRコードの発行を依頼してください。
        </p>
        <button type="submit" class="btn success" v-if="!isLoading">再設定する</button>
        <template v-if="isLoading">
          <loading :message="'再設定中...'"></loading>
        </template>
      </form>
    </div>
  </section>
</template>
  
<script lang="ts">
import { UserApi } from "@/api/UserApi";
import Message from "@/const/Message";
import { DialogService } from "@/service/DialogService";
import { PasswordResetReq, PasswordResetRes } from "@/types/User";
import { defineComponent, Ref, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const req: Ref<PasswordResetReq> = ref({
      email: '',
      token: '',
      password: '',
      password_confirmation: ''
    });

    const router = useRouter()
    const route = useRoute()
    if (route.params.token !== '' && typeof route.params.token === 'string') {
      req.value.token = route.params.token;
    }

    if (route.query['email'] !== '' && typeof route.query['email'] === 'string') {
      req.value.email = route.query['email'];
    }

    const isLoading = ref(false);

    const submit = async () => {
      isLoading.value = true;
      const api = new UserApi();
      let res: PasswordResetRes | null = null;
      try {
        res = await api.resetPassword(req.value);
        if (!res.result) {
          DialogService.error({
            title: Message.ERROR_RESET_PASSWORD,
          })
          return
        }

        DialogService.success({
          title: Message.SUCCESS_RESET_PASSWORD,
          text: 'ログイン画面へ移動します。設定したパスワードでログインしてください。'
        }).then(() => {
          router.push({ name: 'login' })
        })
      } catch (error) {
        DialogService.error({
          text: Message.ERROR_RESET_PASSWORD,
        })
      } finally {
        isLoading.value = false;
      }
    }

    return {
      req,
      submit,
      isLoading
    };
  },
  components: {
  },
});
</script>
  
<style lang="scss" scoped>
@import '@scss/pages/login.scss';
</style>